import {
  assets as selectedThemeAssets,
  components as selectedThemeComponents,
  copy as selectedThemeCopy,
  options as selectedThemeOptions
} from '@theme'

const assets = selectedThemeAssets || {}
const components = selectedThemeComponents || {}
const copy = selectedThemeCopy || {}
const options = selectedThemeOptions || {}

export function resolveThemeComponent(name, defaultComponent) {
  return components[name] || defaultComponent
}

export function resolveThemeCopy(name, defaultTranslationKey) {
  return copy[name] || defaultTranslationKey
}

export function resolveThemeOption(name, defaultValue) {
  return Object.prototype.hasOwnProperty.call(options, name) ? options[name] : defaultValue
}

export function resolveThemeAsset(name, defaultAsset) {
  return assets[name] || defaultAsset
}
